import { render, staticRenderFns } from "./SalesDivisionPage.vue?vue&type=template&id=19abbe3c&"
import script from "./SalesDivisionPage.vue?vue&type=script&lang=js&"
export * from "./SalesDivisionPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports